import {
	Control,
	FieldPath,
	FieldValues,
	Path,
	RegisterOptions,
} from "react-hook-form";

import { formatTwoDigit } from "../../../utils";
import { CommonAutocomplete } from "../Input/CommonAutocomplete";

import "./time_picker.scss";

export const defaultTimeOptions = Array.from({ length: 24 * 4 + 1 }).map(
	(value, index) => ({
		id: index,
		label: `${formatTwoDigit(Math.floor(index / 4))}:${formatTwoDigit((15 * index) % 60)}`,
		value: `${Math.floor(index / 4) * 60 + ((15 * index) % 60)}`,
	}),
);

export type TTimePickerProps<T extends FieldValues> = {
	availableTimes?: { id: number; label: string; value: string }[];
	placeholder?: string;
	name: Path<T>;
	control: Control<T>;
	rules?: Omit<
		RegisterOptions<T, FieldPath<T>>,
		"valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
	>;
};

export function TimePicker<T extends FieldValues>({
	availableTimes = defaultTimeOptions,
	placeholder = "hh:mm",
	name,
	control,
	rules,
}: TTimePickerProps<T>) {
	return (
		<div className="time-selector-container">
			<CommonAutocomplete
				control={control}
				name={name}
				placeholder={placeholder}
				options={availableTimes}
				showEndAdornment={false}
				rules={rules}
			/>
		</div>
	);
}
